import {
  AnswerStatusMark,
  IStyles,
  SquareImageAvatar,
  StatusRadioMark,
  pxToRem,
  pxTovW,
} from '@geneo2-web/shared-ui';
import { Typography } from '@mui/material';
import { Box } from '@mui/system';
import {
  McqMultipleContentModel,
  McqSingleContentModel,
  TfContentModel,
  TfContentModel_AnswerEnum,
  Question,
} from '@protos/content_management/content.db_pb';
import { calculateMarksMCQM } from '../../../../utils/functions';
import {
  IQuestionSessionData,
  IResponses,
  ISessionData,
} from '../../../../app/Context/ClickerAssessmentContextProvider';
import { IStudentClickerDataObj } from '../reducer/clickerAssessment.slice';

// import {
//   IResponses,
//   IStudentClickerDataObj,
//   IQuestionSessionData,
//   ISessionData,
// } from '../../../../app/Context/ConnectedClassContextProvider';

const styles: IStyles = {
  root: {
    width: { xs: '98%', md: '100%' },
    borderRadius: { xs: pxToRem(11), md: pxTovW(15) },
    backgroundColor: '#FFFFFFFF',
    boxSizing: 'border-box',
    boxShadow: {
      xs: `0px 0px ${pxToRem(11)} #00000029`,
      md: `0px 0px ${pxTovW(11)} #00000029`,
    },
    padding: {
      xs: `${pxToRem(12)} ${pxToRem(14)}`,
      md: `${pxTovW(0)} ${pxTovW(20)} ${pxTovW(20)} ${pxTovW(20)}`,
    },
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    alignItems: 'center',
    // maxHeight: { xs: pxToRem(500), md: pxTovW(566) },
    // overflowY: 'scroll',
    '&::-webkit-scrollbar': {
      display: 'none',
    },
    maxHeight: { xs: pxToRem(400), md: pxTovW(750), lg: pxTovW(500) },
    overflowY: 'auto',
  },
  marksWrapper: {
    padding: {
      xs: `${pxToRem(5)} ${pxToRem(13)}`,
      md: `${pxTovW(7)} ${pxTovW(11)}`,
    },
    borderRadius: {
      xs: pxToRem(16),
      md: pxTovW(35),
    },
    border: '1px solid #007CDC',
    marginLeft: '10px',
  },
  marks: {
    fontWeight: 700,
    color: '#007CDC',
  },
};

interface IProps {
  showResponse: boolean;
  question?: Question;
  // students_data?: any[];
  // questionSessionData?: any;
  // baseStationData?: any;
  students_data?: IStudentClickerDataObj[];
  questionSessionData?: IQuestionSessionData;
  baseStationData?: ISessionData;
}

export const ResponseList = ({
  showResponse,
  question,
  students_data,
  questionSessionData,
  baseStationData,
}: IProps) => {
  const questionCase = question?.question?.model.case;
  const maxMarks =
    question?.question?.model.value?.commonQuestionContent?.marks.reduce(
      (acc, curr) => acc + curr,
      0
    ) || 0;

  const correctAnswer =
    question?.question?.model.case === 'tfContentModel' ||
    question?.question?.model.case === 'mcqSingleContentModel' ||
    question?.question?.model.case === 'mcqMultipleContentModel'
      ? question.question.model.value.correct
      : undefined;

  const studentList = students_data?.map((student) => {
    const response = questionSessionData?.responses.find(
      (e: any) => e.keypadSn === student.clickerSerialNo
    );
    return {
      ...student,
      response,
    };
  });

  const checkOnlineStatus = (clickerSerialNo: string) => {
    const keypad = baseStationData?.keyPads?.find(
      (kp: any) => kp.keypadSn === clickerSerialNo
    );
    return keypad?.isOnline ? 'on' : 'off';
  };
  if (!question) {
    return null;
  }

  return (
    <Box sx={styles.root}>
      {studentList?.map((elem) => (
        <Box
          key={elem.studentId.toString()}
          sx={{
            width: '100%',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            paddingY: { xs: pxToRem(15), md: pxTovW(21) },
            borderBottom: '1px solid lightGrey',
          }}
        >
          <Box
            sx={{
              maxWidth: { xs: '80%', md: '70%' },
              display: 'flex',
              alignItems: 'center',
              gap: { xs: pxToRem(10), md: pxTovW(25) },
              textAlign: 'left',
            }}
          >
            <SquareImageAvatar
              size="small"
              name={elem.studentName}
              online={checkOnlineStatus(elem.clickerSerialNo) === 'on'}
            />
            <Typography
              variant="h4"
              sx={{
                textOverflow: 'ellipsis',
                WebkitLineClamp: 3,
                WebkitBoxOrient: 'vertical',
                overflow: 'hidden',
                maxHeight: pxToRem(40),
                maxWidth: '90%',
              }}
            >
              {elem.studentName}
            </Typography>
          </Box>
          <Box>
            {showResponse ? (
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: { xs: pxToRem(21), md: pxTovW(44) },
                }}
              >
                <Box sx={styles.marksWrapper}>
                  <Typography variant="h5" sx={styles.marks}>
                    {correctAnswer && elem.response?.response
                      ? questionCase === 'mcqMultipleContentModel'
                        ? calculateMarksMCQM(question, {
                            answer: elem.response?.response.split(''),
                          })
                        : correctAnswer ===
                          convertAnswerOptionstoNumbers(
                            elem.response?.response,
                            question
                          )
                        ? maxMarks
                        : 0
                      : 0}{' '}
                    Mark
                  </Typography>
                </Box>
                <AnswerStatusMark
                  statusmark={
                    elem.response?.response
                      ? questionCase === 'mcqMultipleContentModel'
                        ? calculateMarksMCQM(question, {
                            answer: elem.response?.response.split(''),
                          }) === maxMarks
                          ? 'on'
                          : 'off'
                        : correctAnswer ===
                          convertAnswerOptionstoNumbers(
                            elem.response?.response,
                            question
                          )
                        ? 'on'
                        : 'off'
                      : 'disconnected'
                  }
                />
              </Box>
            ) : (
              <StatusRadioMark
                status={checkAttemptStatus(elem.response) ? 'on' : 'off'}
              />
            )}
          </Box>
        </Box>
      ))}
    </Box>
  );
};

export const convertAnswerOptionstoNumbers = (
  option: string | undefined,
  questionObj?: Question
) => {
  switch (option) {
    case 'A':
      return '1';
    case 'B':
      return '2';
    case 'C':
      return '3';
    case 'D':
      return '4';
    case '1':
      return TfContentModel_AnswerEnum.TF_ANSWER_T;
    case '2':
      return TfContentModel_AnswerEnum.TF_ANSWER_F;
    default:
      return undefined;
  }
};

// const checkAttemptStatus = (responseObj: IResponses | undefined) => {
//   return responseObj?.response?.split('').length > 0 ?? false;
// };

const checkAttemptStatus = (responseObj?: IResponses): boolean => {
  return !!responseObj?.response?.length;
};
